import { cn } from '@/src/utils';
import Checkbox from '../../atom/Checkbox';
import Label from '../../atom/Label';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

export interface CheckboxWithTextProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  label: string;
  labelClassName?: string;
  value?: string | number;
}

export function CheckboxWithText({
  value,
  label,
  labelClassName,
  ...props
}: CheckboxWithTextProps) {
  return (
    <div className="flex items-center gap-1">
      <Checkbox id={value?.toString()} {...props} />
      <Label
        htmlFor={value?.toString()}
        className={cn(
          'text-b16r leading-none text-gray7 peer-disabled:cursor-not-allowed peer-disabled:text-gray4',
          labelClassName,
        )}
      >
        {label}
      </Label>
    </div>
  );
}
